import React from 'react';

import GameModeModal from '~/components/GameModesModals/GameModeModal';
import Icon from '~/components/Icon';

interface SurvivalModeModalProps {
  onClose: () => void;
}

function SurvivalModeModal({ onClose }: SurvivalModeModalProps) {
  return (
    <GameModeModal
      dataCy="survival-mode-modal"
      title="SURVIVAL MODE"
      modeLabel="Survival Mode"
      ctaTo="/survival"
      onClose={onClose}
    >
      <div className="flex flex-col gap-2">
        <p className="mb-4">You begin with 60 seconds.</p>
        <div className="flex items-center gap-3">
          <Icon name="check" size={6} className="text-green-500" />
          <p>
            <span>Every correct answer give you </span>
            <span className="font-bold text-green-500">+15 sec</span>
          </p>
        </div>

        <div className="flex items-center gap-3">
          <Icon name="thumbsDown" size={6} className="text-red-500" />
          <p>
            <span>Every wrong answer cost you </span>
            <span className="whitespace-nowrap font-bold text-red-500">
              -8 sec
            </span>
          </p>
        </div>

        <div className="flex items-center gap-3">
          <Icon name="arrow" size={6} className="text-purple-200" />
          <p>
            <span>You can skip a game </span>
            <span className="whitespace-nowrap font-bold text-red-500">
              -12 sec
            </span>
          </p>
        </div>
      </div>

      <p>
        <span>The skip penalty increase each time you use it.</span>
      </p>
      <p>
        <span>
          From the 20th game onwards, you have to find the name down to the
          character.
        </span>
      </p>
    </GameModeModal>
  );
}

export default SurvivalModeModal;
